import { chartKeys } from 'utils/constant';

const open_position_in_profit_loss = {
  chartTitle: 'Open position in profit/loss',
  chartKey: chartKeys.OPEN_POSITION_IN_PROFIT_LOSS,
  hoverTextArray: {
    'pips': [
      {
        templateString: '',
        valueKey: 'pips',
        unit: 'pips',
        // textColor: function(hoveredData) {
        //   return hoveredData.pips >= 0? "#56A07E" : "#C15357"
        // }
        followBarColor: true,
      },
      {
        templateString: '',
        valueKey: 'profit',
        // textColor: function(hoveredData) {
        //   return hoveredData.profit >= 0? "#56A07E" : "#C15357"
        // },
        followBarColor: true,
        unit: ' USD'
      },
      {
        templateString: 'Trades: ',
        valueKey: 'trades',
      },
      {
        templateString: 'B: ',
        valueKey: 'pipsBenchmark',
        createLabelColor: function() {
          return '#FFB700';
        },
        textColor: function() {
          return '#FFB700';
        }
      }
    ],
    'percentage': [
      {
        templateString: '',
        valueKey: 'percentage',
        unit: '%',
        // textColor: function(hoveredData) {
        //   return hoveredData.percentage >= 0? "#56A07E" : "#C15357"
        // }
        followBarColor: true,
      },
      {
        templateString: '',
        valueKey: 'profit',
        // textColor: function(hoveredData) {
        //   return hoveredData.profit >= 0? "#56A07E" : "#C15357"
        // },
        followBarColor: true,
        unit: ' USD'
      },
      {
        templateString: 'Trades: ',
        valueKey: 'trades',
      },
      {
        templateString: 'B: ',
        valueKey: 'percentageBenchmark',
        createLabelColor: function() {
          return '#FFB700';
        },
        textColor: function() {
          return '#FFB700';
        }
      }
    ]
  },
  createHoverTextArray: (currency) => {
    return {
      'pips': [
        {
          templateString: '',
          valueKey: 'pips',
          unit: 'pips',
          // textColor: function(hoveredData) {
          //   return hoveredData.pips >= 0? "#56A07E" : "#C15357"
          // }
          followBarColor: true,
        },
        {
          templateString: '',
          valueKey: 'profit',
          // textColor: function(hoveredData) {
          //   return hoveredData.profit >= 0? "#56A07E" : "#C15357"
          // },
          followBarColor: true,
          unit: currency
        },
        {
          templateString: 'Trades: ',
          valueKey: 'trades',
        },
        {
          templateString: 'B: ',
          valueKey: 'pipsBenchmark',
          createLabelColor: function() {
            return '#FFB700';
          },
          textColor: function() {
            return '#FFB700';
          }
        }
      ],
      'percentage': [
        {
          templateString: '',
          valueKey: 'percentage',
          unit: '%',
          // textColor: function(hoveredData) {
          //   return hoveredData.percentage >= 0? "#56A07E" : "#C15357"
          // }
          followBarColor: true,
        },
        {
          templateString: '',
          valueKey: 'profit',
          // textColor: function(hoveredData) {
          //   return hoveredData.profit >= 0? "#56A07E" : "#C15357"
          // },
          followBarColor: true,
          unit: currency
        },
        {
          templateString: 'Trades: ',
          valueKey: 'trades',
        },
        {
          templateString: 'B: ',
          valueKey: 'percentageBenchmark',
          createLabelColor: function() {
            return '#FFB700';
          },
          textColor: function() {
            return '#FFB700';
          }
        }
      ]
    }
  },
  interval: [
    '<-4%',
    '-2%--4%',
    '-2%-0',
    '0',
    '0-2%',
    '2%-4%',
    '>4%'
  ],
}

export default open_position_in_profit_loss;